import { render, staticRenderFns } from "./ResponseHandler.vue?vue&type=template&id=3b2b20ca&scoped=true"
import script from "./ResponseHandler.vue?vue&type=script&lang=js"
export * from "./ResponseHandler.vue?vue&type=script&lang=js"
import style0 from "./ResponseHandler.vue?vue&type=style&index=0&id=3b2b20ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b20ca",
  null
  
)

export default component.exports